import GeneralTab from 'components/desktop/ShoppingCart/Search/tabs/GeneralTab';
import STATUS from 'types/ShoppingCart/Status';

const ApprovedTab = () => {
	return <GeneralTab status={STATUS.APPROVED} />;
};

export default ApprovedTab;
